export default class ConfigurationsModel {
    constructor(model) {
        this.company = new ConfigurationsCompanySettings(model?.company);
        this.misc = new ConfigurationsMiscSettings(model?.misc);
        this.fbr_sidi_api = new ConfigurationsFBRSaleInvDigInvApiSettings(model?.fbr_sidi_api);
    }
}

class ConfigurationsCompanySettings {
    constructor(model) {
        this.name = model?.name || '';
        this.address = model?.address || '';
        this.province = model?.province || '';
        this.phone_nos = model?.phone_nos || '';
        this.fax_nos = model?.fax_nos || '';
        this.email = model?.email || '';
        this.strn = model?.strn || '';
        this.ntn = model?.ntn || '';
        this.slogan = model?.slogan || '';
        this.url = model?.url || '';
        this.head_office = new ConfigurationsCompanyHeadOfficeSettings(model?.head_office);
    }
}

class ConfigurationsCompanyHeadOfficeSettings {
    constructor(model) {
        this.address = model?.address || '';
        this.phone_nos = model?.phone_nos || '';
        this.fax_nos = model?.fax_nos || '';
    }
}

class ConfigurationsMiscSettings {
    constructor(model) {
        this.default_item_hs_code = model?.default_item_hs_code || '';
        this.current_standard_tax_rate = +(model?.current_standard_tax_rate || 0);
        this.current_further_tax_rate = +(model?.current_further_tax_rate || 0);
        this.default_discount_rate = +(model?.default_discount_rate || 0);
    }
}

class ConfigurationsFBRSaleInvDigInvApiSettings {
    constructor(model) {
        this.sandbox_security_token = model?.sandbox_security_token || '';
        this.production_security_token = model?.production_security_token || '';
        this.is_sandbox_enabled = !!model?.is_sandbox_enabled;
        this.is_debug_enabled = !!model?.is_debug_enabled;
    }
}
